import { atom } from 'recoil';

export const employeePagingAtom = atom<number>({
   key: 'employeePagingAtom',
   default: 0,
});
